import { gql } from "apollo-boost";
import useCurrentUserStore from "../../store/userStore";
import { apolloClient, getApolloOptions } from "./apolloClient";


const GET_USER_LOCATIONS = gql`
  query($limit: Int!, $offset: Int!, $userId: ID!) {
    locations(
      where:{users:{id: $userId}}
      limit: $limit
      start: $offset
      sort: "id:asc"
    ) {
      id
      name
      time_zone
      country
      xcubes {
        config
        id
        name
        letter
        type
        active
      }
    }
  }
`;

export const getUserLocationsSimple = async () => {
    const store = useCurrentUserStore();
    if (!store.currentUser) {
        return [];
    }
    const { id } = store.currentUser;
    let result = [];
    let offset = 0;
    let page = [];
    do {
        const res = await apolloClient.query({
            ...getApolloOptions(),
            query: GET_USER_LOCATIONS,
            variables: { limit: 100, offset: offset, userId: id },
        });
        page = res.data.locations;
        result = result.concat(page);
        offset += 100;
    } while (page.length === 100);
    return result;
}
